import { getLogger } from '@sas/nova-core/logging';

import { GetUser as clientGetUser } from '../client/identities/rest';
import { User } from '../representations/common';

// eslint-disable-next-line @sas/i18n/jsx-to-localize
const logger = getLogger('DataSelection');

export const UnknownUserID = 'UNKNOWN';

export const GetUser = async (userID: string): Promise<User> => {
  // lookup user from identities service
  const [user, err] = await clientGetUser(userID);
  if (err) {
    logger.debug(
      `There was an error while getting user ${userID} from the identities service: ${err}. Returning a stub identity instead.`
    );
  }
  if (!user) {
    // return user object with name = id if api call fails for any reason
    return {
      id: userID,
      name: userID,
    };
  }
  return user;
};

export const GetUserFromCache = async (
  userID: string,
  userCacheMap?: Map<string, User>
): Promise<User | undefined> => {
  // return nil if user id not set or unknown
  if (userID === '' || userID === UnknownUserID) {
    logger.debug(`Returning 'undefined' for user ${UnknownUserID}`);
    return undefined;
  }

  // return cached user if found
  if (userCacheMap && userCacheMap.get(userID)) {
    return userCacheMap.get(userID);
  }

  const user = await GetUser(userID);
  if (userCacheMap) {
    userCacheMap.set(userID, user);
  }
  return user;
};
